import { Component, OnInit } from "@angular/core";

import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { State, Section, Rule } from "../../../common/models/flow.dto";
import { deepClone } from "../../models/editor.model";
import { genId } from "../../../core/services/genId";

@Component({
    selector: "state-builder-section-validation",
    templateUrl: "./state-builder-section-validation.component.html",
    standalone: false
})
export class StateBuilderSectionValidationComponent extends SidePanelBase implements OnInit {

    static componentName = "StateBuilderSectionValidationComponent";

    public section: Section;
    public currentState: State;
    public defaultSection: Section = {
        id: "-1",
        name: "..."
    } as Section;

    public defaultRequiredRule: Rule = {
        ruleId: "-1",
        name: "Section is Required",
        expression: "false",
        parseTree: {
            column: 0,
            line: 1,
            nodeType: "BooleanLiteral",
            value: false
        }
    } as Rule;

    public defaultValidRule: Rule = {
        ruleId: "-1",
        name: "Section is Valid",
        expression: "true",
        parseTree: {
            column: 0,
            line: 1,
            nodeType: "BooleanLiteral",
            value: true
        }
    } as Rule;


    get selectedSection(): Section {
        if (!this.section) {
            this.section = this.defaultSection;
        }
        return this.section;
    }
    set selectedSection(selected: Section) {
        this.section = selected;
    }

    get requiredRule(): Rule {
        if (!this.selectedSection.isRequired) {
            this.selectedSection.isRequired = deepClone(this.defaultRequiredRule);
            this.selectedSection.isRequired.ruleId = genId();
        }
        return this.selectedSection.isRequired;
    }

    availableSections: Section[];


    constructor() {
        super();
    }

    ngOnInit() {
        this.availableSections = [];
        this.availableSections.push(this.defaultSection);
        if (this.componentData) {
            if (this.componentData.selectedState) {
                this.currentState = this.componentData.selectedState;
                for (let s = 0; s < this.currentState.sections.length; s++) {
                    this.availableSections.push(this.currentState.sections[s]);
                }
            }
        }
    }
}
